import PacksRequests from '../../server/packs';
import { addLoading, removeLoading } from './loading';

export const getAllPacks = (
  limit,
  skip,
  search,
  orderBy,
  field,
  status,
  pricingType,
  dateFrom,
  dateTo,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PacksRequests.getAllPacks(
      limit,
      skip,
      search,
      orderBy,
      field,
      status,
      pricingType,
      dateFrom,
      dateTo,
    );
  } finally {
    dispatch(removeLoading());
  }
};

export const createPack = newPack => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PacksRequests.createPack(newPack);
  } finally {
    dispatch(removeLoading());
  }
};

export const updatePack = updPack => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PacksRequests.updatePack(updPack);
  } finally {
    dispatch(removeLoading());
  }
};

export const updatePackStatus = (id, status) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PacksRequests.updatePackStatus(id, status);
  } finally {
    dispatch(removeLoading());
  }
};

export const deletePack = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PacksRequests.deletePack(id);
  } finally {
    dispatch(removeLoading());
  }
};

export const getSearchProducts = (limit, search) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PacksRequests.getSearchProducts(limit, search);
  } finally {
    dispatch(removeLoading());
  }
};

export const getPackDetail = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PacksRequests.getPackDetail(id);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadPacks = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await PacksRequests.uploadCsvPacks(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvPacksModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PacksRequests.getCsvPacksModel();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadPackImage = (file, packId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await PacksRequests.uploadPackImage(file, packId);
  } finally {
    dispatch(removeLoading());
  }
};
